import { Box, SpaceBetween, ColumnLayout, StatusIndicator, ExpandableSection, Slider } from '@cloudscape-design/components';
import React, { useEffect, useState } from 'react';
import { fieldDefinition, FieldDefinition } from './common/fieldDefinitionx';
import { formField } from './common/createField';

export default function ItemDetailQualificationChecklist(props: any) {

  const data = props.data;
  const sourceData = props.sourceData;
  const qualiChecklistScore = data.qualiChecklistScore;
  const qualiChecklistType = data.type;

  //Basic Info Fields
  const [oppyDeadline, setOppyDeadline] = useState("");
  const [awsAccountExec, setAwsAccountExec] = useState("");
  const [salesforceOppyURL, setSalesforceOppyURL] = useState("https://aws-crm.lightning.force.com/lightning/r/Opportunity/[Opportunity ID]");
  const [oppyForecastedDate, setOppyForecastedDate] = useState('');
  const [connectSpecialist, setConnectSpecialist] = useState('');

  // Customer Info Fields 
  const [companyName, setCompanyName] = useState("");
  const [companyIndustry, setCompanyIndustry] = useState("");
  const [mainOfficeAddress, setMainOfficeAddress] = useState("");
  const [regionCountry, setRegionCountry] = useState("");
  const [primaryBusinessContactName, setPrimaryBusinessContactName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [emailAddress, setEmailAddress] = useState("");

  // Checklist Input Fields
  const [frameworkTender, setFrameworkTender] = useState("No");
  const [frameworkTenderField, setFrameworkTenderField] = useState(false);
  const [awsCustomer, setAwsCustomer] = useState("No");
  const [influence, setInfluence] = useState("No");
  const [competition, setCompetition] = useState("No");
  const [accountPlan, setAccountPlan] = useState("No");
  const [opportunitySeatSize, setOpportunitySeatSize] = useState("99");
  const [opportunityType, setOpportunityType] = useState("Digital only");
  const [expectedARR, setExpectedARR] = useState(1);
  const [awsSentiment, setAwsSentiment] = useState("No");
  const [partnerRequire, setPartnerRequired] = useState(false);
  const [effort, setEffort] = useState(2);
  const [partnerLed, setPartnerLed] = useState("Yes");
  const [consultingPartner, setConsultinPartner] = useState("No");

  useEffect(() => {
    if (sourceData[0]) {
      setOppyDeadline(sourceData[0].oppyDeadline);
      setAwsAccountExec(sourceData[0].awsAccountExec);
      setCompanyName(sourceData[0].companyName);
      setCompanyIndustry(sourceData[0].companyIndustry);
      setMainOfficeAddress(sourceData[0].mainOfficeAddress);
      setRegionCountry(sourceData[0].regionCountry);
      setPrimaryBusinessContactName(sourceData[0].primaryBusinessContactName);
      setPhoneNumber(sourceData[0].phoneNumber);
      setEmailAddress(sourceData[0].emailAddress);
      setSalesforceOppyURL(sourceData[0].salesforceOppyURL);
      setConnectSpecialist(sourceData[0].connectSpecialist);
      setOppyForecastedDate(sourceData[0].oppyForecastedDate);
      setFrameworkTender(sourceData[0].frameworkTender);
      // Set frameworkTenderField based on frameworkTender value
      setFrameworkTenderField(sourceData[0].frameworkTender === "Yes");
      setAwsCustomer(sourceData[0].awsCustomer);
      setInfluence(sourceData[0].influence);
      setCompetition(sourceData[0].competition);
      setAccountPlan(sourceData[0].accountPlan);
      setOpportunitySeatSize(sourceData[0].opportunitySeatSize);
      setOpportunityType(sourceData[0].opportunityType);
      setExpectedARR(sourceData[0].expectedARR);
      setAwsSentiment(sourceData[0].awsSentiment);
      // Set partnerRequire based on partnerLed value
      setPartnerRequired(sourceData[0].partnerLed === "Yes");
      setEffort(sourceData[0].effort);
      setPartnerLed(sourceData[0].partnerLed);
      setConsultinPartner(sourceData[0].consultingPartner);
    }
  })


  const content =
    (
      <ExpandableSection headerText='Opportunity Information'>
        <ColumnLayout columns={4} variant="text-grid">
          <SpaceBetween size="l">
              <div>
                <Box variant="awsui-key-label">Framework tender</Box>
                <StatusIndicator type={frameworkTenderField ? (frameworkTender == 'Yes' ? 'success' : 'warning') : 'warning'}>
                  {frameworkTenderField ? `${frameworkTender} (Access)` : 'No'}
                </StatusIndicator>
              </div>
              {formField('awsCustomer', awsCustomer)}
              {formField('influence', influence)}
              {formField('competition', competition)}
          </SpaceBetween>

          <SpaceBetween size="l">
          {formField('accountPlan', accountPlan)}
          {formField('opportunitySeatSize', Number(opportunitySeatSize), 100)}
          {formField('opportunityType', opportunityType, ['Voice Only', 'Voice + Digital'])}
          {formField('expectedARR', Number(expectedARR), 0.5, 'M USD')}
          </SpaceBetween>

          <SpaceBetween size="l">
          {formField('awsSentiment', awsSentiment)}
              <div>
                <Box variant="awsui-key-label">Partner Needed</Box>
                <StatusIndicator type={partnerRequire ? 'info' : 'success'}>
                  {partnerRequire ? 'Yes' : 'No'}
                </StatusIndicator>
              </div>
              <div>
                <Box variant="awsui-key-label">{partnerRequire ? 'Share with Partner' : 'Partner Led'}</Box>
                <StatusIndicator type={partnerLed == 'Yes' ? 'success' : 'warning'}>{partnerLed}</StatusIndicator>
              </div>
              {formField('consultingPartner', consultingPartner)}
          </SpaceBetween>

          <SpaceBetween size="l">
            <div>
              <Box variant="awsui-key-label">Estimated Effort</Box>
              <StatusIndicator type={effort === 3 ? 'warning' : effort === 0 ? 'info' : 'success'}>
                {['None', 'Low', 'Medium', 'High'][effort]}
              </StatusIndicator>
            </div>
          </SpaceBetween>
        </ColumnLayout>
      </ExpandableSection>
    )
  return content
}
